import { forwardRef } from "react";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";

import { Text } from "../Typographies/Text";
import classes from "./Tab.module.css";

type TabProps = {
  children: React.ReactNode;
  count?: number | string;
  selected?: boolean;
  icon?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const Tab = forwardRef<HTMLButtonElement, TabProps>(function Tab(
  { children, count, selected = false, icon, onClick },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      className={classes.tab}
      aria-pressed={selected}
      onClick={onClick}
      style={
        {
          "--tab-gap": spacing[1.5],
          "--tab-label-gap": spacing[1],
          "--tab-padding-y": spacing[2.5],
          "--tab-padding-x": spacing[4],
          "--tab-radius": radius.lg,
          "--tab-bg": selected ? colors.bg.elevation.tertiary : colors.bg.elevation.primary,
          "--tab-border-color": selected ? colors.icon.primaryDefault : colors.border.tertiary,
          "--tab-border-width": selected ? "1.5px" : "1px",
        } as React.CSSProperties
      }
    >
      {icon ? <span className={classes.icon}>{icon}</span> : null}
      <span className={classes.label}>
        <Text size="tiny" type="medium" component="span">
          {children}
        </Text>
        {count !== undefined ? (
          <Text
            size="tiny"
            color={colors.text.secondaryDefault}
            component="span"
            style={{ fontFeatureSettings: '"lnum" 1, "pnum" 1' }}
          >
            {count}
          </Text>
        ) : null}
      </span>
    </button>
  );
});

export { Tab };
